import api from "@/axios";

export default {
  findAll() {
    return api().get("city");
  },
  findOne(id) {
    return api().get(`admin/city/${id}`);
  },
  create(data) {
    return api().post("admin/city/add", data);
  },
  update(id, data) {
    return api().patch(`admin/city/${id}`, data);
  },
  remove(id) {
    return api().delete(`city/${id}`);
  },
};
